import {applyMiddleware, compose, createStore} from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers/rootReducer';

export const configureStore = () => {
    return createStore(
        rootReducer,
        compose(
            applyMiddleware(
                thunk
            )
        )
    );
};

export default configureStore;
